export type SituationKey =
    | "activitiesOutings"
    | "morningRoutines"
    | "irritationEscalation"
    | "meals"
    | "eveningRoutines"
    | "hygienePersonalCare";

export type SelectedSituation = { kind: "general"; key: SituationKey } | { kind: "custom"; id: string };

export interface CustomSituationChip {
    id: string;
    label: string;
    description: string;
}

const MAX_LABEL_LEN = 120;
const MAX_DESC_LEN = 400;

export function normalizeRawCompletion(raw: string): string {
    let s = raw.trim();
    if (s.startsWith("```")) {
        const lines = s.split("\n");
        if (lines[0]?.startsWith("```")) {
            lines.shift();
        }
        while (lines.length > 0 && lines[lines.length - 1]?.trim().startsWith("```")) {
            lines.pop();
        }
        s = lines.join("\n").trim();
    }
    const firstNonEmpty = s
        .split("\n")
        .map(line => line.trim())
        .find(line => line.length > 0);
    return firstNonEmpty ?? "";
}

export function parseCustomSituationsJson(normalized: string): CustomSituationChip[] | null {
    try {
        const parsed: unknown = JSON.parse(normalized);
        if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
            return null;
        }
        const rec = parsed as Record<string, unknown>;
        const arr = rec["situations"];
        if (!Array.isArray(arr)) {
            return null;
        }
        const out: CustomSituationChip[] = [];
        for (let i = 0; i < Math.min(arr.length, 2); i++) {
            const item = arr[i];
            if (!item || typeof item !== "object" || Array.isArray(item)) {
                return null;
            }
            const o = item as Record<string, unknown>;
            const l = typeof o["l"] === "string" ? o["l"].trim() : "";
            const d = typeof o["d"] === "string" ? o["d"].trim() : "";
            if (!l || l.length > MAX_LABEL_LEN || d.length > MAX_DESC_LEN) {
                return null;
            }
            out.push({ id: `custom-${i}`, label: l, description: d });
        }
        return out;
    } catch {
        return null;
    }
}

export function decodeCustomSituations(raw: string): CustomSituationChip[] {
    const normalized = normalizeRawCompletion(raw);
    const parsed = parseCustomSituationsJson(normalized);
    return parsed ?? [];
}
